import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { LOGIN, PASSWORD_RESET, PRIVACY, ROOT, TERMS } from '../../../constants/routes';
import formik from './RegisterForm';
import { useFormik } from 'formik';
import Loader from '../../../components/Loader';
import logo from '../../../images/logo.svg';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { selectAuthUser } from '../../../reducers/auth/auth.selectors';
import { FormControl, Form, Modal, InputGroup } from 'react-bootstrap';
import { EmailIcon, Locked, UserIcon } from '../../../components/Icons';
import FooterLinks from '../FooterLinks';
import LoginRegisterHeader from '../../../components/generic-components/LoginRegisterHeader';
import LoginWithGoogle from '../../../components/generic-components/LoginWithGoogle';
import ButtonComponent from '../../../components/generic-components/ButtonComponent';
import LoginTermsAndConditions from '../../../components/generic-components/LoginTermsAndConditions';
import LanguageSwitcher from '../../../components/generic-components/LanguageSwitcher';
import { Dropdown } from 'react-bootstrap';
import API from '../../../API';
import { LanguageArrow } from '../../../components/Icons';

const Register = ({ history }) => {
  const user = useSelector(selectAuthUser);
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const isHebrew = localStorage.getItem('current_language') === 'he';

  const { t, i18n } = useTranslation();

  const location = useLocation();
  const [languagesData, setLanguagesData] = useState([]);
  useEffect(() => {
    if (user) history.push(ROOT);
    const fetchCountries = () => {
      API.get(`languages`).then(res => {
        setLanguagesData(res);
      });
    };

    fetchCountries();
  }, []);
  const handleItemSelect = item => {
    let current_language = localStorage.getItem('current_language');
    if (current_language === item.id) return;
    if (item.id === 'he') {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
    } else {
      document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
    }
    localStorage.setItem('current_language', item.id);
    i18n.changeLanguage(item.id.toLowerCase());
  };

  const { values, handleSubmit, errors, touched, handleChange, status, isSubmitting } = useFormik(
    formik({
      history,
      dispatch,
      location,
    })
  );

  return (
    <div
      className={
        `d-flex flex-column flex-fill pt-4 pb-5 background_dark register-container + ${isHebrew ? 'hebrew' : '' }  ` 
      }
    >
      <LoginRegisterHeader />
      <LoginWithGoogle />

      <Form noValidate className="login-form" onSubmit={handleSubmit}>
        <Loader isLoadin={isSubmitting} height={237} size={60}>
          <div className="d-flex flex-column mx-auto w-100 align-items-center ">
            {status &&
              status.errors &&
              status.errors.filter(err => err[0] !== 'email').map((err, key) => (   
                  <p key={key} className="text-danger">
                    {err[1]}
                  </p>
              ))}

            <div className="form_wrap">
              <div className="input_wrap">
                <Form.Group className="w-100 ">
                  <InputGroup size="lg">
                    <FormControl
                      type="text"
                      className={
                        touched.name && errors.name
                          ? 'input-invalid-error input-field input-login'
                          : 'input-field input-login'
                      }
                      id="name"
                      name="name"
                      autoComplete="off"
                      value={values.name}
                      onChange={handleChange}
                      isInvalid={touched.name && errors.name}
                      required
                    />
                    <label>{t('name')}</label>

                    <Form.Control.Feedback type="invalid" tooltip>
                      {!!errors.name && t(errors.name)}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
            <div className="form_wrap">
              <div className="input_wrap">
                <Form.Group className="w-100">
                  <InputGroup size="lg" style={{display: 'flex', flexDirection: 'column'}}>
                    <FormControl
                      type="text"
                      className={
                        touched.email && errors.email
                          ? 'input-invalid-error input-field input-login'
                          : 'input-field input-login'
                      }
                      id="email"
                      name="email"
                      /*autoComplete='off'*/
                      required
                      value={values.email}
                      onChange={handleChange}
                      isInvalid={touched.email && errors.email || !!status && status.errors}
                      style={{width:'100%'}}
                    />
                    <label>{t('Email')}</label>
                    <Form.Control.Feedback type="invalid" tooltip>
                      {!!errors.email && t(errors.email) || !!status && status.errors.map((err) => err[1])}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
            <div className="form_wrap">
              <div className="input_wrap">
                <Form.Group className="w-100">
                  <InputGroup size="lg">
                    <FormControl
                      className={
                        touched.password && errors.password
                          ? 'input-invalid-error input-field input-login'
                          : 'input-field input-login'
                      }
                      type="password"
                      id="password"
                      name="password"
                      value={values.password}
                      onChange={handleChange}
                      required
                      isInvalid={touched.password && errors.password}
                    />
                    <label>{t('Password')}</label>

                    <Form.Control.Feedback type="invalid" tooltip>
                      {!!errors.password && t(errors.password)}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
            <div className="form_wrap">
              <div className="input_wrap">
                <Form.Group className="w-100">
                  <InputGroup size="lg">
                    <FormControl
                      className={
                        touched.password_confirmation && errors.password_confirmation
                          ? 'input-invalid-error input-field input-login'
                          : 'input-field input-login'
                      }
                      type="password"
                      required
                      id="password_confirmation"
                      name="password_confirmation"
                      value={values.password_confirmation}
                      onChange={handleChange}
                      isInvalid={touched.password_confirmation && errors.password_confirmation}
                    />
                    <label>{t('repeat_password')}</label>
                    <Form.Control.Feedback type="invalid" tooltip>
                      {!!errors.password_confirmation && t(errors.password_confirmation)}
                    </Form.Control.Feedback>
                  </InputGroup>
                </Form.Group>
              </div>
            </div>
            <ButtonComponent
              btnText={t('register')}
              transparent={false}
              customClass={'mt-5 mb-3 btn-gradient custom-sign-in-btn'}
            />

            <p className={'text-lightPurple sign-up-here'}>{t('already_account')}</p>

            <p className={'log-in-here text-white mt-2'}>
              <Link to={LOGIN} className="font-weight-bold">
                {t('Sign in')}
              </Link>
            </p>
          </div>
        </Loader>
      </Form>

      <LoginTermsAndConditions />
      <div style={{ marginTop: '20px', display: 'flex', justifyContent: 'center' }}>
        <Dropdown>
          <Dropdown.Toggle>
            {localStorage.getItem('current_language') &&
            Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language'))
              ?  t(Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language')).name)
              : 'English'}
            <div className='language-arrow'>
              <LanguageArrow />
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu>
            {Object.values(languagesData).map(language => (
              <Dropdown.Item onClick={() => handleItemSelect(language)}>
                <label class="container">
                  <input
                    type="radio"
                    checked={
                      Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language')) &&
                      Object.values(languagesData).find(lang => lang.id === localStorage.getItem('current_language'))
                        .name === language.name
                    }
                    name="radio"
                  />
                  <span class="checkmark"></span>
                </label>
                {t( language.name )}
              </Dropdown.Item>
            ))}
          </Dropdown.Menu>
        </Dropdown>
      </div>
    </div>
  );
};

export default Register;
